module.exports = __webpack_public_path__ + "img/illu_03.16dd909b.svg";